import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import { useContext } from 'react';
import { ColorModeContext } from '../../App';
import MenuButton from './MenuButton';

export default function ThemeToggle() {
  const { mode, toggleColorMode } = useContext(ColorModeContext);

  return (
    <MenuButton aria-label="Changer le thème" onClick={toggleColorMode}>
      {mode === 'dark' ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
    </MenuButton>
  );
}
